const FooterPortal = () => (
    <footer className="text-center p-3 border-top mt-auto bg-light text-light-secondary">
      <small className="pt-4">2025 - INCOOP ©</small>
    </footer>
  );
  
  export default FooterPortal;
  